import { ANNOTATION_TYPE_COLORS } from '@netexknowledge/smart-components';

export const ANNOTATION_TYPES = ['highlight', 'note', 'textNote'];

// Chips order: "all" first, then the types in the order of the design.
export const ANNOTATION_FILTERS = [
  { type: 'all', labelKey: 'annotations.filters.all' },
  ...ANNOTATION_TYPES.map(type => ({
    type,
    labelKey: `annotations.filters.${type}`,
    colors: ANNOTATION_TYPE_COLORS[type]
  }))
];

// Same shortcuts the reader binds in smart-content (modules/highlight.js).
export const ANNOTATION_SHORTCUTS = {
  highlight: 'Ctrl+Alt+H',
  unhighlight: 'Ctrl+Alt+U',
  textNote: 'Ctrl+Alt+Y'
};

// Color of the reader action buttons shown inside help texts.
export const READER_ACTION_COLOR = '#12ABE3';
